<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-clipboard-check"></i> ใบรับสินค้า</h4>

          <div class="d-flex align-items-center mx-1 my-3 gap-2">
            <b-form-input
              type="search"
              class="flex-grow-1"
              autofocus
              v-model="filter"
              placeholder="ค้นหาใบรับสินค้า จากรหัสใบรับสินค้า รหัสใบสั่งซื้ออ้างอิง หรือชื่อผู้ขาย"
            ></b-form-input>
            <b-button
              class="flex-shrink-0"
              style="width: 300px;"
              variant="primary"
              @click="openCreateModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="goodsReceiveTable"
            ref="goodsReceiveTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getGoodsReceiveList"
            :fields="fields"
            :filter="filter"
            sort-by="createdAt"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(createdAt)="row">
              {{ formatDate(row.value) }}
            </template>
            <template v-slot:cell(buttons)="row">
              <div class="action-icons">
                <span class="icon-tooltip-wrapper" data-tooltip="ดูข้อมูลใบรับสินค้า">
                  <i
                    class="fas fa-info-circle action-icon info-icon"
                    @click="openDetailModal(row.item)"
                  ></i>
                </span>
                <span
                  :class="{
                    'icon-tooltip-wrapper': isEditable(row.item),
                  }"
                  data-tooltip="แก้ไขใบรับสินค้า"
                >
                  <i
                    class="fas fa-edit action-icon edit-icon"
                    :class="{ 'icon-disabled': !isEditable(row.item) }"
                    @click="isEditable(row.item) && openEditModal(row.item)"
                  ></i>
                </span>
                <span
                  :class="{
                    'icon-tooltip-wrapper': isEditable(row.item),
                  }"
                  data-tooltip="ลบใบรับสินค้า"
                >
                  <i
                    class="fas fa-trash-alt action-icon delete-icon icon-delete-hover"
                    :class="{ 'icon-disabled': !isEditable(row.item) }"
                    @click="isEditable(row.item) && deleteGoodsReceive(row.item)"
                  ></i>
                </span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <GoodsReceiveItem ref="goodsReceiveItemModal"></GoodsReceiveItem>
      <GoodsReceiveDetail ref="goodsReceiveDetailModal"></GoodsReceiveDetail>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import GoodsReceiveItem from "../../components/modal/ProductAndStock/GoodsReceiveItem.vue";
import GoodsReceiveDetail from "../../components/modal/ProductAndStock/GoodsReceiveDetail.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import { THAI_MONTHS } from "@/constants";
import Loading from "@/components/Loading";

export default {
  name: "GoodsReceive",
  components: {
    GoodsReceiveItem,
    GoodsReceiveDetail,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      deleteTarget: null,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "4%" },
          tdClass: "index-cell",
        },
        {
          key: "grCode",
          label: "รหัสใบรับสินค้า",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
        },
        {
          key: "poRefCode",
          label: "รหัสใบสั่งซื้ออ้างอิง",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
        },
        {
          key: "vendorName",
          label: "ชื่อผู้ขาย",
          sortable: true,
          thStyle: { width: "22%", whiteSpace: "nowrap" },
          tdClass: "vendor-name-cell",
        },
        {
          key: "createdAt",
          label: "วันที่สร้าง",
          sortable: true,
          sortDirection: "desc",
          thStyle: { width: "18%", whiteSpace: "nowrap" },
        },
        {
          key: "buttons",
          label: "",
          thStyle: { width: "12%" },
          class: "text-center",
        },
      ],
      filter: null,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getGoodsReceiveList: "moduleGoodsReceive/getGoodsReceiveList",
      getProductList: "moduleProductInventory/getProductList",
    }),
  },
  methods: {
    ...mapActions({
      fetchGoodsReceiveList: "moduleGoodsReceive/fetchGoodsReceiveList",
      fetchProductList: "moduleProductInventory/fetchProductList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchGoodsReceiveList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
        // Try fetching real product list; ignore error if API not ready
        await this.fetchProductList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        }).catch(() => {});
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการใบรับสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    openCreateModal() {
      this.$refs.goodsReceiveItemModal.show({
        productList: this.getProductList,
      });
    },
    openEditModal(goodsReceive) {
      this.$refs.goodsReceiveItemModal.show({
        goodsReceive,
        productList: this.getProductList,
      });
    },
    openDetailModal(goodsReceive) {
      this.$refs.goodsReceiveDetailModal.show(goodsReceive);
    },
    deleteGoodsReceive(item) {
      this.deleteTarget = item;
      this.$refs.Dialog.showAlertConfirm(
        "ลบใบรับสินค้านี้ ?",
        "คุณต้องการลบใบรับสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;

        this.$store
          .dispatch("moduleGoodsReceive/deleteGoodsReceive", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: this.deleteTarget.id,
          })
          .then(res => {
            if (res.status === 200) {
              this.deleteTarget = null;
              this.init();
              this.showDialogToast("success", "ลบรายการใบรับสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบใบรับสินค้าไม่สำเร็จ กรุณาลองใหม่";
            this.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const day = date.getDate();
      const month = THAI_MONTHS[date.getMonth()];
      const year = String(date.getFullYear()).slice(-2);
      return `${day} ${month} ${year}`;
    },
    isEditable(item) {
      if (!item || !item.createdAt) return false;
      const cutoff = new Date(item.createdAt);
      if (isNaN(cutoff.getTime())) return false;
      cutoff.setHours(23, 0, 0, 0);
      return new Date() <= cutoff;
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped>
::v-deep #goodsReceiveTable {
  table-layout: auto;
}

::v-deep #goodsReceiveTable thead th {
  padding: 16px 24px;
}

::v-deep #goodsReceiveTable tbody td {
  padding: 16px 24px;
  vertical-align: middle;
}

::v-deep .index-cell {
  white-space: nowrap;
}

::v-deep .vendor-name-cell {
  word-break: break-word;
  white-space: normal;
}

.action-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.icon-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-tooltip-wrapper::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #212529;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  padding: 4px 8px;
  border-radius: 8px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 10000;
}

.icon-tooltip-wrapper::before {
  content: "";
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #212529;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 10001;
}

.icon-tooltip-wrapper:hover::after,
.icon-tooltip-wrapper:hover::before {
  opacity: 1;
}

.action-icon {
  font-size: 20px;
  color: #adb5bd;
  cursor: pointer;
}

.icon-delete-hover:hover {
  color: #d33 !important;
}

.action-icon:hover:not(.icon-disabled) {
  color: #1976D2;
}

.info-icon {
  font-size: 20px;
}

.icon-disabled {
  color: #dee2e6;
  cursor: not-allowed;
  pointer-events: none;
}

.gap-2 {
  gap: 0.5rem;
}

::v-deep #deleteConfirmModal .modal-footer {
  border-top: none;
  padding: 0 1rem 1rem;
}

.delete-modal-footer {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
}

.delete-modal-btn {
  padding: 8px 24px;
}

.btn-back {
  background-color: #fff;
  border-color: #212529;
  color: #212529;
}

.btn-back:hover {
  background-color: #f8f9fa;
  border-color: #212529;
  color: #212529;
}

@media (max-width: 576px) {
  ::v-deep #goodsReceiveTable thead th,
  ::v-deep #goodsReceiveTable tbody td {
    padding: 10px 12px;
  }

  .action-icons {
    gap: 10px;
  }

  .action-icon {
    font-size: 20px;
  }
}
</style>
